import React, {useState} from "react";

function UserGroupManageSidebarList({items = [], selectedId, onSelect, onCreate}) {
    const [draft, setDraft] = useState("");

    const submitCreate = () => {
        const trimmed = draft.trim();
        if (!trimmed) {
            return;
        }
        onCreate?.(trimmed);
        setDraft("");
    };

    return (
        <div className="code-manage-item-list company-manage-item-list">
            <p className="code-manage-item-list__heading">그룹 목록</p>
            <div className="code-manage-item-list__scroll code-manage-scroll-area company-manage-item-list__scroll">
                {!items?.length ? (
                    <p className="code-manage-item-list__empty">
                        등록된 그룹이 없습니다. 아래에서 추가하세요.
                    </p>
                ) : (
                    <ul className="sidebar-flat-list company-manage-sidebar">
                        {items.map((item) => {
                            const isSelected = selectedId === item.id;
                            return (
                                <li
                                    key={item.id}
                                    className={`sidebar-flat-list__item company-manage-sidebar__item ${isSelected ? "is-selected" : ""}`}
                                >
                                    <button
                                        type="button"
                                        className="sidebar-flat-list__label"
                                        onClick={() => onSelect(item)}
                                    >
                                        <span className="sidebar-flat-list__name">{item.name}</span>
                                    </button>
                                </li>
                            );
                        })}
                    </ul>
                )}
            </div>

            {onCreate && (
                <div className="code-manage-item-list__create">
                    <p className="code-manage-item-list__create-label">그룹 추가</p>
                    <div className="code-manage-item-list__create-row">
                        <input
                            type="text"
                            className="code-manage-item-list__create-input basic-input input-style"
                            placeholder="새 그룹명을 입력하세요"
                            value={draft}
                            onChange={(e) => setDraft(e.target.value)}
                            onKeyDown={(e) => {
                                if (e.key === "Enter") {
                                    submitCreate();
                                }
                            }}
                        />
                        <button
                            type="button"
                            className="save-btn"
                            onClick={submitCreate}
                        >
                            등록
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
}

export default UserGroupManageSidebarList;
